module.exports = __webpack_public_path__ + "media/view.9d2c039a593580168370fa5c19a1699e.svg";